import request from '@/utils/request'

export function getData(data) {
    return request({
        url: '/backend/activity/chakras/getData',
        method: 'post',
        data: data
    })
}

export function getList(data) {
    return request({
        url: '/backend/activity/chakras/list',
        method: 'post',
        data: data
    })
}

export function getChakrasDataList(data) {
    return request({
        url: '/backend/activity/chakras/dataList',
        method: 'post',
        data: data
    })
}

export function getUserDataList(data) {
    return request({
        url: '/backend/activity/chakras/userList',
        method: 'post',
        data: data
    })
}

export function getLockBagList(data) {
    return request({
        url: '/backend/activity/chakras/lockBagList',
        method: 'post',
        data: data
    })
}
//
export function getUserWinningList(data) {
    return request({
        url: '/backend/activity/chakras/userWinningList',
        method: 'post',
        data: data
    })
}

export function createChakras(data) {
    return request({
        url: '/backend/activity/chakras/create',
        method: 'post',
        data: data
    })
}

export function getChakrasInfo(data) {
    return request({
        url: '/backend/activity/chakras/info',
        method: 'post',
        data: data
    })
}

export function updateChakras(data) {
    return request({
        url: '/backend/activity/chakras/update',
        method: 'post',
        data: data
    })
}

export function updateChakrasOnline(data) {
    return request({
        url: '/backend/activity/chakras/online',
        method: 'post',
        data: data
    })
}

export function chakrasDelete(data) {
    return request({
        url: '/backend/activity/chakras/delete',
        method: 'post',
        data: data
    })
}

//获取活动参与人列表
export function chakrasUserList(data) {
    return request({
        url: '/backend/activity/chakras/chakrasUserList',
        method: 'post',
        data: data
    })
}

//添加中奖人
export function updateChakrasWinner(data) {
    return request({
        url: '/backend/activity/chakras/updateChakrasWinner',
        method: 'post',
        data: data
    })
}